import { UpdateUserInput } from '@tripointe/tripointe-cms/data-access';

export interface User {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
}

export enum AccessLevel {
  platformAdministrator = 'Platform Administrator',
  builderAdministrator = 'Builder Administrator',
  divisionAdministrator = 'Division Administrator',
  administrator = 'Community Administrator',
  user = 'New Home Advisor'
}

export enum UserFormBlock {
  permissions = 'permissions',
  communities = 'communities',
  divisions = 'divisions'
}

export const USER_FORM_BLOCKS_VISIBILITY = {
  [AccessLevel.platformAdministrator]: [UserFormBlock.permissions],
  [AccessLevel.builderAdministrator]: [UserFormBlock.permissions],
  [AccessLevel.divisionAdministrator]: [UserFormBlock.permissions, UserFormBlock.divisions],
  [AccessLevel.administrator]: [UserFormBlock.permissions, UserFormBlock.communities],
  [AccessLevel.user]: [UserFormBlock.permissions, UserFormBlock.communities]
};

export const ADMIN_ROLES = [AccessLevel.platformAdministrator, AccessLevel.builderAdministrator];

export interface UserPendingSaving {
  userData: UpdateUserInput;
  newRole: AccessLevel;
}
